<tt-page *ngIf="!!edit">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input *ngIf="colorGrpId === '0'" ttLabel="colorgrp_id" [(ttModel)]="edit.colorgrp_id"></tt-input>
        <tt-input *ngIf="colorGrpId !== '0'" ttLabel="colorgrp_id" [ttModel]="edit.colorgrp_id" ttReadonly></tt-input>
        <tt-input ttLabel="colorgrp_name" [(ttModel)]="edit.colorgrp_name"></tt-input>
        <tt-input-number ttLabel="sortorder" [(ttModel)]="edit.sortorder" ttTextAlign="right" ttFormatNumber ttDecimals></tt-input-number>
        <tt-button-save ttText="colorgrp_save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
    </tt-card>
</tt-page>
